module.exports = __webpack_public_path__ + "img/bg-desktop.170afc6.webp";